import en from './en'
import cn from './cn'
import ind from './in'
import kr from './kr'
import ru from './ru'
import tr from './tr'
import vi from './vi'

export default {
  cn,
  en,
  in: ind,
  kr,
  ru,
  tr,
  vi,
}
